import Keycloak from 'keycloak-js';
import config from './config';

const keycloak = new Keycloak({
    realm: config.app.authRealm,
    clientId: config.app.authClientId,
    url: config.app.authUrl
});

export default keycloak;
